import routes from './../routes'
import vue from 'vue'
import {filterResponse, filterErrors} from './../client'

export const postLogin = (phone, password) => {
    return vue.http.post(routes.user.login, {
        phonenumber: phone,
        pin: password
    }).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const postRegister = (data) => {
    return vue.http.post(routes.user.signup, data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const requestOTP = ($otp) => {
    return vue.http.post(routes.user.requestOTP).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const requestOTPToBlockAccount = (phonenumber) => {
    return vue.http.post(routes.user.requestOTPToBlockAccount, {
        phonenumber: phonenumber
    })
        .then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const verifyBlockOTP = (phonenumber, reason, otp) => {
    return vue.http.post(routes.user.verifyBlockOTP, {
        phonenumber: phonenumber,
        otp: otp,
        reason: reason
    })
        .then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}


export const verifyOTP = ($otp) => {
    return vue.http.post(routes.user.verifyOTP, {
        otp: $otp
    }).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const postForget = (data) => {
    return vue.http.post(routes.user.forget, data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const postReset = (pin) => {
    return vue.http.post(routes.user.reset, {"pin": pin}).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const putUpdateProfile = (data) => {
    return vue.http.put(routes.user.updateProfile, data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const postUpdateAvatar = (data) => {
    return vue.http.post(routes.user.updateAvatar, data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}